// Cookie helpers
export function setCookie(cname: string, cvalue: string | number, exdays?: number | null | undefined) {
  let expires = '';
  if (exdays !== undefined && exdays !== null) {
    const date = new Date();
    date.setTime(date.getTime() + exdays * 24 * 60 * 60 * 1000);
    expires = `expires=${date.toUTCString()};`;
  }
  document.cookie = `${cname}=${encodeURIComponent(cvalue)};${expires}path=/`;
}

export function getCookie(cname: string) {
  const name = `${cname}=`;
  const decodedCookie = decodeURIComponent(document.cookie);
  const ca = decodedCookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c?.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c?.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
}
